export function getCustomerMatches(context, { customerId, searchResultId }) {
  let searchResult = context.stores.universalSearchResults.findBy({ id: searchResultId });
  return searchResult && searchResult.hits.filter(c => c.id !== customerId);
}
